import { generateSteps } from './generateSteps'

/**
 * Generates CSS for gradient.
 *
 */
export const generateCss = (colors: string[], weights?: number[]): string => {
  // Si potrebbe fare tutto con un unico map, ma tengo separato per far capire un po' meglio cosa sto facendo
  const steps = generateSteps(colors, weights)

  return steps
    .map(
      (step, index) => `${colors[Math.floor(index / 2)]} ${step.toString()}%`,
    )
    .join(',\n')
}
